import * as Sentry from '@sentry/react';
import { type IK_PROCESS_ERROR, IK_PROCESS_ERRORS, type TEAM_CATEGORY } from 'cpool-constants';
import type { TFunction } from 'i18next';
import { toast } from 'react-toastify';

const isIKProcessError = (code: unknown): code is IK_PROCESS_ERROR =>
    (Object.values(IK_PROCESS_ERRORS) as Array<unknown>).includes(code);

// sendCommand puts the backend error code into `response`
export const toastIKProcessError = ({
    category,
    error,
    t,
}: {
    category: TEAM_CATEGORY;
    error: unknown;
    t: TFunction;
}) => {
    const code = error && typeof error === 'object' && 'response' in error ? error.response : undefined;
    const team = t(`TEAMS.CATEGORIES.${category}`);

    if (isIKProcessError(code)) {
        toast.error(t(`LEADS.IK_PROCESS.ERRORS.${code}`, { team }));
        return;
    }
    Sentry.captureException(error, { extra: { category } });
    toast.error(t('LEADS.IK_PROCESS.ERRORS.GENERAL'));
};
